import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { EntityPageTemplate } from 'hocs/withEntityPageTemplate';
import { clearCurrentSubscription } from '@redux/features/subscriptionsSlice';
import { selectEntriesByClient } from '@redux/features/selectors/entriesSelector';
import { getClient, updateClient } from '@redux/features/clientsSlice';
import { getEntries } from '@redux/features/entriesSlice';
import { MoneyAmount } from 'components/MoneyAmount';
import styles from 'pages/Database/Clients/ClientPage/Balance.scss';

export const ClientPage = () => {
  const { clients } = useSelector((state) => state.clients);
  const { clientID } = useParams();
  const dispatch = useDispatch();

  const entries = useSelector((state) => selectEntriesByClient(state, clientID));

  useEffect(() => {
    dispatch(clearCurrentSubscription());
    if (!clients.map((c) => c.id).includes(Number(clientID))) {
      dispatch(getClient(clientID));
    }
    dispatch(getEntries({ entityRole: 'client', entityID: clientID }));
  }, []);

  const client = useMemo(() => clients.find(({ id }) => id === Number(clientID)), [clients]);
  const clientEntries = useMemo(
    () => entries.filter((entry) => entry.participants.some(({ id }) => id == clientID)),
    [entries]
  );

  const formattedClientEntries = useMemo(
    () =>
      clientEntries.map((entry) => ({
        ...entry,
        locationName: entry.location?.name,
        hallName: entry.hall?.name,
        createdAt: entry.metadata?.createdAt,
      })),
    [clientEntries]
  );

  const handleUpdate = async (updatedData) => await dispatch(updateClient(updatedData));

  if (!client) return null;

  return (
    <>
      <EntityPageTemplate
        backButtonPath='database/clients'
        backButtonText='Список клієнтів'
        entity={client}
        entityType='client'
        onEntityNameUpdate={handleUpdate}
        entries={formattedClientEntries}
        noResultsText='У клієнта ще не було записів'
        renderProfileExtra={() => (
          <div className={styles.row}>
            Баланс:
            <MoneyAmount value={client.balance} />
          </div>
        )}
      >
      </EntityPageTemplate>
    </>
  );
};
